module.exports = __webpack_public_path__ + "img/course_Image_seven.71866754.png";